'use client';

import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Css, ITheme } from '../../../ui';

type SubheadingType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5';

interface ISubheading {
	type: SubheadingType;
	children: ReactNode;
}

const fontSizeMap: Record<SubheadingType, string> = {
	h1: Css.pxToRem(52),
	h2: Css.pxToRem(40),
	h3: Css.pxToRem(28),
	h4: Css.pxToRem(19),
	h5: Css.pxToRem(14),
};

export default function Subheading({ type, children }: ISubheading) {
	return (
		<SubheadingText type={type} className="subheading">
			{children}
		</SubheadingText>
	);
}

const SubheadingText = styled.span<{ type: SubheadingType }, ITheme>`
	display: block;
	font-family: ${(props) => props.theme.typography.subheading.font.fontFamily};
	color: ${(props) => props.theme.color.secondaryLight};
	font-size: ${(props) => fontSizeMap[props.type]};
	font-weight: ${(props) => props.theme.typography.subheading.font.fontWeight};
`;
